// extracted by mini-css-extract-plugin
export default {"scrollCircle":"ScrollCircle_scrollCircle__Ac3wg","left":"ScrollCircle_left__CCnr0","right":"ScrollCircle_right__admE4","arrow":"ScrollCircle_arrow__UHmbj"};